export default __webpack_public_path__ + "static/media/DisSumTestGet.4d8f7c37.svg";